import { GROUPS } from '~/common/helpers';
import { TranslationKeys } from '~/common/types';

export const USER_GROUPS_LOOKUP: Record<string, keyof TranslationKeys> = {
  [GROUPS.GROUP_WTB_BASE]: 'app.user.groups.wtb_base',
  [GROUPS.GROUP_SUPERADMIN]: 'app.user.groups.superadmin',
  [GROUPS.GROUP_IAM_ADMIN]: 'app.user.groups.iam_admin',
  [GROUPS.GROUP_PLATFORM_SETUP]: 'app.user.groups.platform_setup',
  [GROUPS.GROUP_SUPPORT]: 'app.user.groups.support',
  [GROUPS.GROUP_CUSTOMER_RELATIONSHIP]: 'app.user.groups.customer_relationship',
  [GROUPS.GROUP_MARKETING]: 'app.user.groups.marketing',
  [GROUPS.GROUP_PLATFORM_ADMIN]: 'app.user.groups.platform_admin',
  [GROUPS.GROUP_CALL_CENTER]: 'app.user.groups.call_center',
  [GROUPS.GROUP_BUYER]: 'app.user.groups.buyer',
  [GROUPS.GROUP_CUSTOMER_MANAGER]: 'app.user.groups.customer_manager',
  [GROUPS.GROUP_CONSULTANT]: 'app.user.groups.consultant',
  [GROUPS.GROUP_QUOTE]: 'app.user.groups.quote',
  [GROUPS.GROUP_REDISTRIBUTION_PRICING_POLICY]:
    'app.user.groups.redistribution_pricing_policy',
  [GROUPS.GROUP_SELLER]: 'app.user.groups.seller',
  [GROUPS.GROUP_ADVANCED_QUOTE]: 'app.user.groups.advanced_quote',
  [GROUPS.GROUP_QUOTE_SETTINGS]: 'app.user.groups.quote_settings',
  [GROUPS.GROUP_REDISTRIBUTION_IMPORT]: 'app.user.groups.redistribution_import',
  [GROUPS.GROUP_CONTAINER_SUPPLIER]: 'app.user.groups.supplier',
  [GROUPS.GROUP_CONTAINER_BUYER]: 'app.user.groups.container_buyer',
  [GROUPS.GROUP_PURCHASE_ADMIN]: 'app.user.groups.purchase_admin',
};
